import { detectDeployment } from "./Utilities";

export function otlAPIs() {
  const config = {
    serviceAPI: true,
    localService:
      "https://dev2.cost-clarity.com/postcontract/apis/otlservice/v1.0",
    deployedService: "/postcontract/apis/otlservice/v1.0",
  };

  // Local dev https://localhost:44383/v1.0/
  // Deployed dev https://dev2.cost-clarity.com/postcontract/apis/otlservice/v1.0

  const D = detectDeployment(config);

  return {
    //Locations
    get_otl_locations: `${D}/OtlService/get_locations`,
    get_otl_entities: `${D}/OtlService/get_otl_entities`,
  };
}
